import React from 'react';
import {BASE_URL} from "./Constants";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import EditField from "./EditField";
import Button from "./Button";
import SelectField from "./SelectField";
import ErrorBox from "./ErrorBox";
import Cookies from "js-cookie";

class Profile extends React.Component {

    state = {
        type: Cookies.get('type'),
        isLoading: true,
        isEditing: true,
        profile: [],
        errors: null,
        errorMessage: null,
        isSending: false,
        newImage: null,
        newFImage: null
    }

    constructor(props) {
        super(props);

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
        this.showChangePassword = this.showChangePassword.bind(this);
        this.showDeleteAccount = this.showDeleteAccount.bind(this);
        this.chooseFile = this.chooseFile.bind(this);
        this.chooseFileF = this.chooseFileF.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.onFileFChange = this.onFileFChange.bind(this);
    }

    componentDidMount() {
        if(this.state.type == "2") {

            return window.location.href = "/";;
        }
        this.loadData();
    }

    loadData() {
        axios.get(BASE_URL + (this.state.type == "1" ? "/user/profile/index" :  "/user/customer/index"))
            .then(result => {
                const profile = result.data.data;

                if (profile.profile !== null) {
                    this.setState({
                        profile: {
                            firstname: profile.profile.firstname,
                            lastname: profile.profile.lastname,
                            telephone: profile.profile.telephone,
                            language: profile.profile.language,
                            company: profile.profile.company,
                            email: profile.email,
                            street: profile.profile.street,
                            zip: profile.profile.zip,
                            city: profile.profile.city,
                            web: profile.profile.web,
                            profile: profile.profile,

                            salutation: profile.profile.salutation ?? "sir",

                            image: profile.image
                        },
                        isLoading: false,
                        errors: null,
                        errorMessage: null,
                        newImage: null,
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errors: null,
                        errorMessage: null
                    });
                }
            });
    }

    ErrorsView() {
        const { errors } = this.state;
        const { errorMessage } = this.state;

        return (
            errorMessage !== null ?
                <ErrorBox errorMessage={ errorMessage } errors={ errors } />
                : null
        );
    }

    LoadingView() {
        return (
            <LoadingSpinner title="Laden..."/>
        );
    }

    chooseFile() {
        this.state.inputElement.click();
    }

    chooseFileF() {
        this.state.inputHeadElement.click();
    }

    onFileChange(event) {
        this.setState({
            newImage: event.target.files[0],
            newImagePreview: URL.createObjectURL(event.target.files[0])
        });
    }
    onFileFChange(event) {
        this.setState({
            newFImage: event.target.files[0],
            newFImagePreview: URL.createObjectURL(event.target.files[0])
        });
    }


    ProfileImageEditButton() {
        return (
            this.state.isEditing ?
                <div className="profile-profilePicture-editButton" onClick={ this.chooseFile } />
                : null
        );
    }

    ProfileView() {
        return (
            <div>
                {
                    this.state.newImage !== null ?
                        <div className="profile-profilePicture" style={{backgroundImage: "url('user-solid.svg')"}}>
                            <img style={{width: "180px", height: "180px", borderRadius: "90px"}}
                                 src={this.state.newImagePreview} alt=""/>
                            {this.ProfileImageEditButton()}
                        </div>
                        :
                        this.state.profile.image === null ?
                            <div className="profile-profilePicture" style={{backgroundImage: "url('user-solid.svg')"}}>
                                {
                                    this.ProfileImageEditButton()
                                }
                            </div>
                            :
                            <div className="profile-profilePicture" style={{
                                backgroundImage: "url('" + this.state.profile.image.url + "')",
                                backgroundSize: "cover"
                            }}>
                                {
                                    this.ProfileImageEditButton()
                                }
                            </div>
                }

                <form>
                    <input type="file" className="hiddenUpload" accept=".png,.jpeg,.jpg" onChange={this.onFileChange}
                           ref={input => this.state.inputElement = input}
                    />
                </form>


                <p className="heading-small">{this.state.profile.firstname} {this.state.profile.lastname}</p>
                <div className="spacer20"/>
                <div className="spacer20"/>
                <EditField label="Firma" name="company" value={this.state.profile.company ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>

                <EditField label="Vorname" name="firstname" value={this.state.profile.firstname ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>
                <EditField label="Nachname" name="lastname" value={this.state.profile.lastname ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>

                <EditField label="Straße" name="street" value={this.state.profile.street ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>
                <EditField label="PLZ" name="zip" value={this.state.profile.zip ?? ""} onChange={this.handleFieldChange}
                           disabled={!this.state.isEditing}/>
                <EditField label="Ort" name="city" value={this.state.profile.city ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>

                <EditField label="E-Mail" name="email" value={this.state.profile.email ?? ""}
                           onChange={this.handleFieldChange} disabled={!this.state.isEditing}/>

                <EditField label="Web" name="web" value={this.state.profile.web ?? ""} onChange={this.handleFieldChange}
                           disabled={!this.state.isEditing}/>

                <div className="spacer20"/>
                <div className="spacer20"/>

                <h3>
                    Unterschrift
                </h3>
                <div>


                    {

                    }
                    {
                        this.state.newFImage == null && this.state.profile.profile.signature == null ?
                            <p>Keine Unterschrift vorhanden</p> :
                            <img
                                src={this.state.newFImage !== null ? this.state.newFImagePreview : this.state.profile.profile.signature.url}
                                style={{maxWidth: 200}}/>
                    }


                    <p onClick={this.chooseFileF} style={{
                        width: "120px",
                        textAlign: "center",
                        padding: 10,
                        borderRadius: 10,
                        backgroundColor: '#eee',
                        cursor: "pointer"
                    }}>bearbeiten</p>

                    <form>
                        <input type="file" className="hiddenUpload" accept=".png,.jpeg,.jpg"
                               onChange={this.onFileFChange}
                               ref={input => this.state.inputHeadElement = input}
                        />
                    </form>
                </div>

                <div className="spacer20"/>

                <Button showLoadingState={this.state.isSending}
                        title={this.state.isEditing ? "Profil sichern" : "Profil bearbeiten"}
                        onClick={this.toggleEditMode}/>

                {
                    this.ErrorsView()
                }


            </div>
        );
    }

    handleFieldChange(event) {
        const value = event.target.value;
        const name = event.target.name;

        this.setState(prevState => ({
            profile: {
                ...prevState.profile,
                [name]: value,
            }
        }));
    }

    toggleEditMode() {
        if (this.state.isEditing) {
            this.saveProfile();
        } else {
            this.setState({isEditing: !this.state.isEditing});
        }
    }

    showChangePassword() {
        this.props.history.push("/profile/password");
    }

    showDeleteAccount() {
        this.props.history.push("/profile/delete");
    }

    saveProfile() {

        this.setState({isSending: true});

        const url = BASE_URL + '/user/profile/update';
        const formData = new FormData();


        if (this.state.newImage !== null) {
            formData.append('image', this.state.newImage);
        }

        if (this.state.newFImage !== null) {
            formData.append('image_signature', this.state.newFImage);
        }

        formData.append('salutation', this.state.profile.salutation ?? "sir");
        formData.append('company', this.state.profile.company);
        formData.append('firstname', this.state.profile.firstname);
        formData.append('lastname', this.state.profile.lastname);
        formData.append('web', this.state.profile.web);
        formData.append('email', this.state.profile.email);
        formData.append('street', this.state.profile.street);
        formData.append('zip', this.state.profile.zip);
        formData.append('city', this.state.profile.city);


        const config = {
            headers: {
                'Accept': 'application/json',
                'content-type': 'multipart/form-data'
            }
        }

        return axios.post(url, formData, config)
            .then(() => {
                this.setState({ isSending: false, isEditing: false, errors: null, errorMessage: null });

                this.loadData();
            }).catch(error => {
                console.log(error.response)
                if (error.response) {
                    this.setState({ isSending: false, errors: error.response.data.errors, errorMessage: error.response.data.message });
                }
            });
    }

    render() {
        return (
            <div className="wrapper">
                <div className="titlebar">
                    <p className="titlebar-title">Mein Profil</p>
                </div>

                <div className="content">
                    {
                        this.state.isLoading ? this.LoadingView() : this.ProfileView()
                    }
                </div>
            </div>
        );
    }
}

export default Profile;
